import  { useEffect, useState } from "react";
import NinVerification from "./NinVerification";
import { useNavigate } from "react-router";
import FaceVerification from "./FaceVerification";

const KYCLevelTwoDetails = ({
  onBack,
  data,
  reload,
  setReload,
  setShowLevelTwoDetails,
  setShowLevelThreeDetails,
}) => {
  const [step, setStep] = useState("requirements");
  const navigate = useNavigate();
  const { onboardingProgress, onboardingStatus } = data;
  const { pendingItems } = onboardingProgress || {};

  console.log("onboardingProgress:", onboardingProgress);

  const proceedToNextStep = (requirement) => {
    if (requirement && requirement.item) {
      setStep(requirement.item); // Set the step dynamically based on the requirement
    }
  };

  useEffect(() => {
    if (onboardingStatus !== "Level 2") {
      onBack(); // This will reset the detail views
      setShowLevelTwoDetails(false); // Close Level Two
      setShowLevelThreeDetails(true); // Show Level Three
    } else if (pendingItems.length === 0) {
      onBack(); // This will reset the detail views
      setShowLevelTwoDetails(false); // Close Level Two
      setShowLevelThreeDetails(true); // Show Level Three
    }
  }, [pendingItems, onBack, setShowLevelThreeDetails, setShowLevelTwoDetails]);

  if (step === "nin_Verification") {
    return (
      <NinVerification
        onBack={() => setStep("requirements")}
        data={data}
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  if (step === "facial_verification") {
    return (
      <FaceVerification
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
        data={data}
      />
    );
  }

  return (
    <div className="w-full md:w-[650px] mx-auto p-4">
      <button onClick={onBack} className="text-blue-600 text-sm mb-4">
        Back
      </button>
      <h3 className="text-xl font-semibold text-gray-800 mb-4">
        Level Two KYC Details
      </h3>
      <div className="bg-primary-color text-white text-lg rounded-lg px-6 py-4 flex justify-between items-center my-[50px]">
        <span>Verification Requirements</span>
        <button
          onClick={() => proceedToNextStep(pendingItems[0])}
          className="bg-white text-primary-color font-semibold px-8 py-4 rounded-md"
        >
          Proceed
        </button>
      </div>
      <div className="border border-gray-300 rounded-b-lg">
        {pendingItems?.map((requirement, index) => (
          <div
            key={index}
            className="flex items-center px-4 py-8 border-b border-gray-200"
          >
            <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
              <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
            </div>
            <span className="text-gray-700 capitalize">
              {requirement?.item?.replace("_", " ")}
            </span>{" "}
          </div>
        ))}
      </div>
    </div>
  );
};

export default KYCLevelTwoDetails;
